import type { ReactNode } from 'react';

import { PageHeader } from '../SurfacePage';

export type AdminPageHeaderProps = {
  title: string;
  description?: string;
  actions?: ReactNode;
};

/**
 * Single consistent page title for admin module routes. The module shell
 * owns the top-level `<h1>`; panels must not duplicate it.
 */
export function AdminPageHeader({
  title,
  description,
  actions,
}: AdminPageHeaderProps) {
  return (
    <PageHeader
      kicker="Admin"
      title={title}
      description={description}
      actions={actions}
    />
  );
}
